module.exports = __webpack_public_path__ + "img/sample-report-10@3x.c91e116c.png";